import {ContentEditableHtmlEditorPlugin} from '@frontapp/editor-html';

import {maybeFixSabreAssets} from '../../../../helpers/pasteHtmlHelpers';

export function createProcessInsertedHtmlPlugin(): ContentEditableHtmlEditorPlugin {
  return {
    preProcessInsertedHtml: (dirtyHtml) => maybeFixSabreAssets(dirtyHtml),
  };
}
